import Vue from 'vue';
import Router from 'vue-router';
// import demo from './modules/demo' // 首页
import index from './modules/index'; // 首页
import refund from './modules/refund'; // 退货路由
import integrity from './modules/integrity'; // 诚信路由
import travelAgency from './modules/travelAgency'; // 个人中心
import appraise from './modules/appraise'; // 考核路由
import complaint from './modules/complaint'; // 退货路由
import guideSystem from './modules/guideSystem';
import appointment from './modules/appointment'; // 分时预约
import resourcesManage from './modules/resourcesManage'; // 旅游资源管理
import noticeManage from './modules/noticeManage'; // 通知公告路由
import batch from './modules/batch'; // 批量审核
import feedback from './modules/feedback'; // 批量审核

// import investment from './modules/investment'; //新 招商引资路由


// import assess from './modules/assess'; // 综合监管考核路由
import appraiseNew from './modules/appraiseNew'; //新 综合监管考核路由

import investment from './modules/investment'; //新 招商引资路由

import instantMessaging from './modules/instantMessaging';  // 即时通信

import itineraryUniversal from './modules/itineraryUniversal'; // 新全场景行程单详情
import store from '../store/index'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router);

// 导游系统
// 重新组织后导出
var routes = [
  ...index,
  ...refund,
  ...travelAgency,
  ...appraise,
  ...guideSystem,
  ...complaint,
  ...integrity,
  ...appointment,
  ...noticeManage,
  ...batch,
  ...investment,
  ...appraiseNew,
  ...resourcesManage,
  ...feedback,
  ...investment,
  ...instantMessaging,
  ...itineraryUniversal
];
const router = new Router({
  mode: 'hash',
  linkExactActiveClass: 'active',
  // 解决vue框架页面跳转有白色不可追踪色块的bug
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  },
  // base: process.env.BASE_URL,
  routes: routes
});
router.beforeEach((to, from, next) => {
  console.log('----router.beforeEach监听:', to.path);
  console.log('----router.beforeEach监听:', from.path);
  next();
});
router.afterEach((to, from, next) => {
  console.log('router.afterEach监听：', to.path);
  if (to.path !== '/guide/info' || to.path !== '/guide/blacklist') {
    window.scrollTo(0, 0);
  }
  if (!to.meta.unwantedSetTitle) {
    console.log('------进来了吗')
    // alert(1);
    window.yyn.invokeJSB('setActionBar', {
      searchBar: 0
    })
    window.yyn.invokeJSB(
      'setTitle',
      {
        title: to.meta.title || ''
      }
    );
  }

  // 设置全局背景色
  document.body.style.setProperty('background', to.meta?.background || 'initial')
});
/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError(error => {
  const pattern = /Loading chunk (\d)+ failed/g;
  console.log(error, 'router error');
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  if (isChunkLoadFailed) {
    // router.replace(targetPath);
    console.log('----测试一下，如果再次遇到路由死循环，用这个方法是否有效');
    location.reload();//测试一下先
  }
});
export default router;
